/** CRM account tiers — controls sidebar pages and route access. */
export const CRM_ACCOUNT_TYPES = {
  FULL: 'full',
  SETTER: 'setter',
  CLOSER: 'closer',
};

const ALL_PAGES = [
  'dashboard',
  'pipeline',
  'email',
  'scripts',
  'meetings',
  'schedule',
  'lead-gen',
  'leads',
  'add-lead',
  'settings',
  'manage',
  'calendar',
];

const PAGE_ACCESS = {
  // Owners use the Meetings Calendar instead of Schedule.
  [CRM_ACCOUNT_TYPES.FULL]: ALL_PAGES.filter((page) => page !== 'schedule'),
  // Setters book their own follow-up calls on the Meetings Calendar, so they don't need Schedule.
  [CRM_ACCOUNT_TYPES.SETTER]: ['dashboard', 'pipeline', 'email', 'scripts', 'calendar'],
  // Closers' Settings is where they connect Google Calendar.
  [CRM_ACCOUNT_TYPES.CLOSER]: ['dashboard', 'pipeline', 'email', 'meetings', 'calendar', 'settings'],
};

export function normalizeCrmAccountType(value) {
  const v = String(value || '').trim().toLowerCase();
  if (v === CRM_ACCOUNT_TYPES.SETTER || v === CRM_ACCOUNT_TYPES.CLOSER) return v;
  if (v === CRM_ACCOUNT_TYPES.FULL || v === 'owner') return CRM_ACCOUNT_TYPES.FULL;
  return null;
}

export function crmPagesForAccountType(accountType) {
  const type = normalizeCrmAccountType(accountType) || CRM_ACCOUNT_TYPES.FULL;
  return PAGE_ACCESS[type] || PAGE_ACCESS[CRM_ACCOUNT_TYPES.FULL];
}

export function crmCanAccessPage(accountType, pageId) {
  return crmPagesForAccountType(accountType).includes(pageId);
}

export function isCrmAccountType(value) {
  return normalizeCrmAccountType(value) != null;
}

/** Legacy CRM owner email — treated as full access when crm_account_type is unset. */
export const LEGACY_CRM_OWNER_EMAIL = 'freakded6@gmail.com';

export function isLegacyCrmOwnerEmail(email) {
  return (email || '').toLowerCase().trim() === LEGACY_CRM_OWNER_EMAIL;
}
